<template>
    <router-link :to="to" :class="{ selected: selected }">{{ filter.name }}</router-link>
</template>

<script>
import { createURI } from "@/utils/string";

export default {
    props: ["filter"],
    computed: {
        to() {
            const query = { ...this.$route.query, category: this.filter.id };
            if (this.selected) {
                delete query.category;
            }
            return createURI(this.$route.path, query);
        },
        selected() {
            return this.$route.query.category === this.filter.id;
        }
    }
};
</script>
<style lang="scss" scoped>
a {
    text-decoration: none;
    color: gray;
    word-wrap: none;
    &:active {
        color: black;
    }

    &.selected {
        color: purple;
        font-weight: bold;
    }

    & + a {
        margin-left: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// CategoryFilter.vue?2054cefa